import { render, staticRenderFns } from "./OtherPersonsEditPanel.vue?vue&type=template&id=11f8d242"
import script from "./OtherPersonsEditPanel.vue?vue&type=script&lang=js"
export * from "./OtherPersonsEditPanel.vue?vue&type=script&lang=js"
import style0 from "./OtherPersonsEditPanel.vue?vue&type=style&index=0&id=11f8d242&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports